export default {
  default: {
    title: 'Estimado usuario',
    subtitle: 'Ha ocurrido un error.',
    extended_subtitle: 'Por favor inténtalo de nuevo mas tarde.'
  },
  time_out: {
    title: 'Estimado usuario',
    subtitle: 'Ha ocurrido un error en la conexión.',
    extended_subtitle: 'Por favor inténtalo de nuevo mas tarde.'
  },
  permanent_blacklist: {
    title: 'Estimado usuario',
    subtitle:
      'No es posible ingresar al portal debido a que tiene registros de transacciones no reconocidas.',
    extended_subtitle:
      'Lo invitamos a realizar su compra en cualquier tienda Claro o banco del sistema.'
  },
  temporal_blacklist: {
    title: 'Estimado usuario',
    subtitle: 'Tu línea presenta un bloqueo temporal por exceder el número de intentos.',
    extended_subtitle: 'Por favor inténtalo dentro de 24 horas.'
  },
  max_day_attempts: {
    title: 'Estimado usuario',
    subtitle: 'No es posible realizar la compra al número solicitado, favor de intentar nuevamente.'
  },
  line_suspended: {
    title: 'Estimado usuario',
    subtitle: 'Tu teléfono se encuentra suspendido.',
    more_info: '¿Necesitas ayuda?',
    extended_more_info: 'Comunícate con nosotros vía Whatsapp al 50433007373 para ser asistido.'
  },
  empty_package: {
    title: 'Estimado usuario',
    subtitle: 'No hay oferta disponible.'
    // extended_subtitle: 'Intente de nuevo más tarde.'
    // more_info: 'Más información en info.cecla@htech.com'
  },
  bin_not_whitelist: {
    title: 'Compra no exitosa',
    subtitle:
      'Hemos detectado que su transacción no ha sido procesada debido a que la forma de pago utilizada no pertenece a un Banco Nacional. Para poder realizar compras en nuestro sitio favor de enviarnos los primeros 8 dígitos del frente de su tarjeta, país y número móvil de la compra a tarjetas@h-tech-solutions.com.'
  },
  short_link_error: {
    title: 'Estimado usuario',
    subtitle:
      'Este paquete no está disponible para tu número, ingresa a nuestro portal para revisar las demás opciones disponibles para ti.'
  },
  invalid_msisdn: {
    title: 'Estimado usuario',
    subtitle: 'Teléfono digitado es incorrecto o no pertenece a Claro.',
    more_info: '¿Necesitas ayuda?',
    extended_more_info: 'Comunícate con nosotros vía Whatsapp al 50433007373 para ser asistido.'
  }
}
